export default __webpack_public_path__ + "static/remeltedwax-ef54d502e83feffc61430fa1fc0ec080.png";